import React from "react";
import {
  Card,
  CardContent,
  CardHeader,
  Typography,
  Grid,
  Button,
} from "@material-ui/core";
import useStyles from "./styles";
import { DPCheckbox } from "Components/DP";
import { useEmailSubscriptions } from "./useEmailSubscriptions";
import { errorToast } from "Modules/DPToast";
import { NotificationSettingsKeys } from "./EmailSubscriptionModels";
import { ProviderPermissions } from "generated/graphql";

const subscriptionLabels = {
  actionRequiredEmailSubscribed: "Direct Deposit Updates Needed Emails",
  payrollJournalReminderSubscribed: "Missing Net Earnings File Emails",
  earningsReminderSubscribed: "Missing Gross Earnings File Emails",
  offCycleDisbursementApprovalSubscribed: "Disbursement Pending Approval Emails",
};

type Props = {
  permissions: ProviderPermissions;
  offCyclePaymentRequiresApproval: boolean;
};

const EmailSubscriptions = ({ permissions, offCyclePaymentRequiresApproval }: Props) => {
  const classes = useStyles();
  const {
    checkboxes,
    handleChange,
    clearSelection,
    loading,
    error,
    onAppyClickHandler,
    isApplying,
  } = useEmailSubscriptions(permissions, offCyclePaymentRequiresApproval);

  if (error) {
    errorToast(
      "Sorry, we encountered a problem loading your settings. Please try again later."
    );
  }

  if (loading) {
    return null;
  }

  const headingTitle = (
    <Typography className={classes.headingText}>Email Subscriptions</Typography>
  );

  return (
    <Card variant={"outlined"} className={classes.container}>
      <CardHeader className={classes.heading} title={headingTitle} />
      <CardContent>
        <Grid
          container
          direction={"column"}
          className={classes.checkboxContainer}
        >
          {checkboxes &&
            Object.keys(checkboxes).map(key => {
              const notificationSettingsKey = key as NotificationSettingsKeys;
              return (
                <Grid item key={key}>
                  <DPCheckbox
                    key={key}
                    value={key}
                    label={subscriptionLabels[notificationSettingsKey]}
                    checked={checkboxes[notificationSettingsKey]}
                    onChange={handleChange}
                  />
                </Grid>
              );
            })}
        </Grid>
        <Grid container spacing={4}>
          <Grid item>
            <Button
              disabled={isApplying}
              variant={"contained"}
              color={"primary"}
              onClick={onAppyClickHandler}
            >
              Apply
            </Button>
          </Grid>
          <Grid item>
            <Button variant={"text"} onClick={clearSelection}>
              Clear selection
            </Button>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default EmailSubscriptions;
